module.exports = __webpack_public_path__ + "static/img/4-role.b8d4b24.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer4/4-role.png
// module id = 33iA
// module chunks = 1